import { Component, OnInit,AfterViewInit, Input, PLATFORM_ID, Inject, HostListener,
      trigger,
      state,
      style,
      transition,
      animate
 } from '@angular/core';
import { isPlatformBrowser, isPlatformServer, PlatformLocation } from '@angular/common'
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { StateInteractionService } from 'angular-engine/engine/service/dynamic/state.interaction.service';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/takeUntil';
import { Subject } from 'rxjs/Subject';
import { MetaService } from 'angular-engine/engine/service/meta/meta.service';
import { ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { RESPONSE } from 'angular-engine/modules/ng-express-engine/tokens';
import { UserLoginService } from 'angular-engine/engine/service/user/user.login.service';
//import { Meta, Title } from '@angular/platform-browser';


@Component({
  selector: 'notfound-container',
  templateUrl: './notfound-container.template.html',
  styleUrls: ['./notfound-container.style.scss'],
  providers: [
    MetaService
  ]
})
export class NotFoundContainer {
  @Input() content: any;
  @Input() isServer: boolean;
  @Input() statusMessage: string;
  @Input() isUserPage: boolean;
  @Input() statusCode: number;

  private metaSubscription : Subscription;
  private componentFunctionString: string;
  private routeSnapshotParams;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  public hideOutput : boolean = false;

  constructor(
    private coreEffects: CoreEffects,
    private stateInteraction: StateInteractionService,
    @Inject(PLATFORM_ID) private platformId: string,
    private ref: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
    private authService: UserLoginService,
    private metaService: MetaService,
    private location: PlatformLocation,
    @Inject(RESPONSE) private response:any
  ) {
    this.isServer = isPlatformServer(this.platformId);
  }


  private jsonEqual(a,b) {
      return JSON.stringify(a) === JSON.stringify(b);
  }
  ngAfterViewInit(){
    
  }
  
		
  ngOnInit() {
    this.content = this.coreEffects.getRouteDataAsObservable({}, '/search');

    if(this.isServer)
    {
      if(this.statusCode !== undefined)
      {
        this.response.statusCode = this.statusCode;

        if(this.isUserPage)
        {
          this.hideOutput = true;
        }
      }
      else
      {
        this.response.statusCode = 404;
      }
    }

    if(this.statusMessage == undefined)
    {
      this.statusMessage = "404 Not Found";
    }

    this.content.takeUntil(this.ngUnsubscribe).subscribe(data => {
      if(!this.isServer)
        {
          if(this.router.navigated) {
            window.scrollTo(0, 0);
          }

          var navCheck:any = document.getElementById('main-nav-check');
          if (navCheck){
            navCheck.checked = false;
          }
        }
    });

    //this.componentFunctionString = this.route.snapshot.component.toString().substring(0, this.route.snapshot.component.toString().indexOf("("));
    //this.routeSnapshotParams = this.route.snapshot.params;

    this.metaSubscription = this.content.subscribe((data:any) => {
      this.metaService.processMeta( {
                                      "title": this.statusMessage
                                    } );
    });

    /*this.router.events.filter(event => event instanceof NavigationEnd).takeUntil(this.ngUnsubscribe).subscribe((val:NavigationEnd) => {
      const navigateToComponent = this.route.snapshot.component.toString().substring(0, this.route.snapshot.component.toString().indexOf("("));
      const navigateToParams = this.route.snapshot.params;
      if (navigateToComponent == this.componentFunctionString && !(this.jsonEqual(this.routeSnapshotParams, navigateToParams))){
        this.coreEffects.getRouteDataAsObservable(this.route.snapshot.params, val.url);//.subscribe();
        this.ref.detectChanges();
        this.routeSnapshotParams = navigateToParams;
      }
    });*/
  }

  public login() {
    this.authService.login();
  }

  ngOnDestroy() {
    this.location = null;
    this.content = null;
    
    if(this.ngUnsubscribe)
    {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
      this.ngUnsubscribe.unsubscribe();
    }
    
    if(this.metaSubscription)
    {
      this.metaSubscription.unsubscribe();
    }
    
  }
  
//   protected getApiUrlData(item: Object, routeParams: any) {
//     return this.coreEffects.getAsyncChildDataAsObservable(item, routeParams, false);
//   }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/containers/notfound-container/notfound-container.component.ts